document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.westy-booking').forEach((booking) => {
    const form = booking.closest('form');
    if (!form) return;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const nativeQuantityWrappers = form.querySelectorAll('.product-info__quantity, quantity-selector, .quantity-selector');
    nativeQuantityWrappers.forEach((el) => {
      const wrapper = el.closest('.product-info__quantity') || el;
      wrapper.classList.add('westy-hide-native-quantity');
    });

    const steps = Array.from(booking.querySelectorAll('.westy-step'));
    const stepPills = Array.from(booking.querySelectorAll('.westy-step-pill'));
    const progressFill = booking.querySelector('[data-progress-fill]');

    const vehicleCountWrap = booking.querySelector('[data-vehicle-count-wrap]');
    const vehicleCountNote = booking.querySelector('[data-vehicle-count-note]');
    const vehicleCountSelect = booking.querySelector('.westy-vehicle-count');
    const vehiclesContainer = booking.querySelector('.westy-vehicles');
    const submitButton = booking.querySelector('.westy-booking__submit');

    const hiddenVehicleCount = booking.querySelector('input[name="properties[Vehicle count]"]');
    const hiddenEstimated = booking.querySelector('input[name="properties[_estimated_minutes]"]');
    const hiddenEmployees = booking.querySelector('input[name="properties[_recommended_employees]"]');
    const hiddenVans = booking.querySelector('input[name="properties[_recommended_vans]"]');
    const hiddenBookingMode = booking.querySelector('input[name="properties[_booking_mode]"]');
    const hiddenVariantTitle = booking.querySelector('input[name="properties[_selected_variant_title]"]');

    const estimatedMinutesOut = booking.querySelector('[data-estimated-minutes]');
    const recommendedEmployeesOut = booking.querySelector('[data-recommended-employees]');
    const recommendedVansOut = booking.querySelector('[data-recommended-vans]');

    let currentStep = 1;

    function toInt(value, fallback = 0) {
      const parsed = parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function isFieldVisible(field) {
      if (!field) return false;
      if (field.closest('.is-hidden')) return false;
      if (field.closest('.westy-step') && !field.closest('.westy-step').classList.contains('is-active')) return false;
      return true;
    }

    function getFieldValue(name) {
      return booking.querySelector(`[name="${name}"]`)?.value || '';
    }

    function setText(selector, value, fallback = '—') {
      const el = booking.querySelector(selector);
      if (!el) return;
      el.textContent = String(value || '').trim() ? value : fallback;
    }

    const defaultMinutesPerVehicle = toInt(booking.dataset.defaultMinutesPerVehicle, 120);
    const defaultMinEmployees = toInt(booking.dataset.defaultMinEmployees, 1);
    const defaultMaxCars = toInt(booking.dataset.defaultMaxCars, 4);

    const targetMinutesPerEmployee = 240;
    const employeesPerVan = 2;

    let variantData = {};
    const variantDataScript = booking.querySelector('.westy-variant-booking-data');

    if (variantDataScript) {
      try {
        variantData = JSON.parse(variantDataScript.textContent.trim());
      } catch (error) {
        console.error('Could not parse Westy variant booking data', error);
      }
    }

    function getVariantMeta() {
      return variantData[String(variantInput.value)] || {};
    }

    function isVariantDriven(meta = getVariantMeta()) {
      return toInt(meta.vehicle_count, 0) > 0;
    }

    function getEffectiveVehicleCount(meta = getVariantMeta()) {
      if (isVariantDriven(meta)) return toInt(meta.vehicle_count, 1);
      return toInt(vehicleCountSelect.value, 1);
    }

    function getEffectiveMinutesPerVehicle(meta = getVariantMeta()) {
      return toInt(meta.minutes_per_vehicle, defaultMinutesPerVehicle);
    }

    function getEffectiveMinEmployees(meta = getVariantMeta()) {
      return toInt(meta.minimum_employees, defaultMinEmployees);
    }

    function populateVehicleCountOptions() {
      vehicleCountSelect.innerHTML = '';

      for (let i = 1; i <= defaultMaxCars; i++) {
        const option = document.createElement('option');
        option.value = String(i);
        option.textContent = String(i);
        vehicleCountSelect.appendChild(option);
      }
    }

    function getCurrentVehicleData() {
      const data = {};

      vehiclesContainer.querySelectorAll('.westy-vehicle-card').forEach((card) => {
        const index = card.getAttribute('data-vehicle-index');
        if (!index) return;

        data[index] = {
          vehicle: card.querySelector(`[name="properties[Vehicle ${index}]"]`)?.value || '',
          color: card.querySelector(`[name="properties[Vehicle ${index} color]"]`)?.value || '',
          plate: card.querySelector(`[name="properties[Vehicle ${index} plate]"]`)?.value || '',
          notes: card.querySelector(`[name="properties[Vehicle ${index} notes]"]`)?.value || ''
        };
      });

      return data;
    }

    function renderVehicleFields(count, existingData = {}) {
      vehiclesContainer.innerHTML = '';

      for (let i = 1; i <= count; i++) {
        const saved = existingData[String(i)] || {};

        const card = document.createElement('div');
        card.className = 'westy-vehicle-card';
        card.setAttribute('data-vehicle-index', String(i));

        card.innerHTML = `
          <h4>Vehicle ${i}</h4>

          <div class="field">
            <label>Year / Make / Model</label>
            <input
              type="text"
              name="properties[Vehicle ${i}]"
              placeholder="2021 Audi S5"
              value="${escapeHtml(saved.vehicle)}"
              required
            >
          </div>

          <div class="field">
            <label>Color</label>
            <input
              type="text"
              name="properties[Vehicle ${i} color]"
              value="${escapeHtml(saved.color)}"
              required
            >
          </div>

          <div class="field">
            <label>Plate</label>
            <input
              type="text"
              name="properties[Vehicle ${i} plate]"
              value="${escapeHtml(saved.plate)}"
            >
          </div>

          <div class="field field--full">
            <label>Vehicle ${i} notes</label>
            <textarea
              name="properties[Vehicle ${i} notes]"
              rows="3"
              placeholder="Oxidation, pet hair, child seats, access concerns, etc."
            >${escapeHtml(saved.notes)}</textarea>
          </div>
        `;

        vehiclesContainer.appendChild(card);
      }
    }

    function recalc(meta = getVariantMeta()) {
      const vehicleCount = getEffectiveVehicleCount(meta);
      const minutesPerVehicle = getEffectiveMinutesPerVehicle(meta);
      const minEmployees = getEffectiveMinEmployees(meta);

      const totalMinutes = vehicleCount * minutesPerVehicle;
      const recommendedEmployees = Math.max(
        minEmployees,
        Math.ceil(totalMinutes / targetMinutesPerEmployee)
      );
      const recommendedVans = Math.max(
        1,
        Math.ceil(recommendedEmployees / employeesPerVan)
      );

      hiddenVehicleCount.value = String(vehicleCount);
      hiddenEstimated.value = String(totalMinutes);
      hiddenEmployees.value = String(recommendedEmployees);
      hiddenVans.value = String(recommendedVans);
      hiddenVariantTitle.value = meta.title || '';

      estimatedMinutesOut.textContent = `${totalMinutes} min`;
      recommendedEmployeesOut.textContent = String(recommendedEmployees);
      recommendedVansOut.textContent = String(recommendedVans);

      updateReview();
    }

    function updateReview() {
      const address = getFieldValue('properties[Appointment address]');
      const city = getFieldValue('properties[City]');
      const state = getFieldValue('properties[State]');
      const zip = getFieldValue('properties[ZIP]');
      const notes = getFieldValue('properties[Access notes]');
      const locationLine = [address, [city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');

      setText('[data-review-date]', getFieldValue('properties[Preferred date]'));
      setText('[data-review-window]', getFieldValue('properties[Preferred time window]'));
      setText('[data-review-phone]', getFieldValue('properties[Phone]'));
      setText('[data-review-location]', locationLine);
      setText('[data-review-notes]', notes, 'None provided');
      setText('[data-review-vehicle-count]', hiddenVehicleCount.value);
      setText('[data-review-labor]', hiddenEstimated.value ? `${hiddenEstimated.value} min` : '');
      setText('[data-review-employees]', hiddenEmployees.value);
      setText('[data-review-vans]', hiddenVans.value);
    }

    function syncMode() {
      const meta = getVariantMeta();
      const variantDriven = isVariantDriven(meta);
      const currentVehicleData = getCurrentVehicleData();

      let vehicleCount;

      if (variantDriven) {
        vehicleCount = getEffectiveVehicleCount(meta);
        vehicleCountWrap.classList.add('is-hidden');
        vehicleCountNote.textContent = 'Vehicle count is set by the selected package.';
        vehicleCountSelect.value = String(vehicleCount);
        hiddenBookingMode.value = 'variant_driven';
      } else {
        vehicleCount = getEffectiveVehicleCount(meta);
        vehicleCountWrap.classList.remove('is-hidden');
        vehicleCountNote.textContent = '';
        hiddenBookingMode.value = 'manual_vehicle_count';

        if (!vehicleCountSelect.value) {
          vehicleCountSelect.value = '1';
          vehicleCount = 1;
        }
      }

      renderVehicleFields(vehicleCount, currentVehicleData);
      recalc(meta);
    }

    function updateStepUI() {
      steps.forEach((step) => {
        const stepNumber = toInt(step.dataset.step, 1);
        step.classList.toggle('is-active', stepNumber === currentStep);
      });

      stepPills.forEach((pill) => {
        const stepNumber = toInt(pill.dataset.stepJump, 1);
        pill.classList.toggle('is-active', stepNumber === currentStep);
        pill.classList.toggle('is-complete', stepNumber < currentStep);
      });

      if (progressFill) {
        const width = ((currentStep - 1) / (steps.length - 1)) * 100;
        progressFill.style.width = `${width}%`;
      }

      booking.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function validateFields(fields) {
      for (const field of fields) {
        if (!isFieldVisible(field)) continue;

        if (!String(field.value || '').trim()) {
          field.focus();
          alert('Please complete all required fields before continuing.');
          return false;
        }
      }

      return true;
    }

    function validateCurrentStep() {
      const currentPanel = booking.querySelector(`.westy-step[data-step="${currentStep}"]`);
      if (!currentPanel) return true;
      const requiredFields = currentPanel.querySelectorAll('[required]');
      return validateFields(requiredFields);
    }

    function validateAllRequired() {
      const requiredFields = booking.querySelectorAll('[required]');
      return validateFields(requiredFields);
    }

    function collectProperties() {
      const properties = {};

      booking.querySelectorAll('[name^="properties["]').forEach((field) => {
        const match = field.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        properties[match[1]] = field.value;
      });

      return properties;
    }

    populateVehicleCountOptions();
    syncMode();
    updateStepUI();

    vehicleCountSelect.addEventListener('change', () => {
      syncMode();
    });

    booking.addEventListener('input', () => {
      updateReview();
    });

    booking.addEventListener('change', () => {
      updateReview();
    });

    booking.querySelectorAll('[data-step-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!validateCurrentStep()) return;
        currentStep = Math.min(currentStep + 1, steps.length);
        updateStepUI();
      });
    });

    booking.querySelectorAll('[data-step-back]').forEach((button) => {
      button.addEventListener('click', () => {
        currentStep = Math.max(currentStep - 1, 1);
        updateStepUI();
      });
    });

    stepPills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const targetStep = toInt(pill.dataset.stepJump, 1);

        if (targetStep < currentStep) {
          currentStep = targetStep;
          updateStepUI();
          return;
        }

        if (targetStep === currentStep) return;

        if (!validateCurrentStep()) return;
        currentStep = targetStep;
        updateStepUI();
      });
    });

    let lastVariantId = variantInput.value;

    setInterval(() => {
      if (variantInput.value !== lastVariantId) {
        lastVariantId = variantInput.value;
        syncMode();
      }
    }, 250);

    submitButton.addEventListener('click', async () => {
      if (!validateAllRequired()) return;

      const meta = getVariantMeta();
      const variantDriven = isVariantDriven(meta);
      const vehicleCount = getEffectiveVehicleCount(meta);
      const quantity = variantDriven ? 1 : vehicleCount;
      const variantId = Number(variantInput.value);
      const properties = collectProperties();

      submitButton.disabled = true;
      submitButton.textContent = 'Sending to checkout...';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
                properties
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error('Could not add booking to cart');
        }

        window.location.href = '/checkout';
      } catch (error) {
        console.error(error);
        alert('There was a problem starting your booking. Please try again.');
        submitButton.disabled = false;
        submitButton.textContent = 'Continue to checkout';
      }
    });
  });
});